import { Dispatch, RootState } from 'store';
import { createSelector } from 'reselect';
import { getQaCookies, getLang, getDomain, getHostname, getCountryCode } from 'utils';
import { createFeatureSelector } from 'common/create-feature-selector';
import { getEnv } from 'common/selectors/env';
import { fetchStoresThunk } from './stores-slice';
import { GetStoresConfig } from './api';

export const rootSelector = createFeatureSelector('stores');
export const getStoresList = createSelector(rootSelector, (s) => s.data);
export const getRegionById = (id: string) => createSelector(getStoresList, (s) => s?.[id]);
export const getStoresByRegion = (id: string) => createSelector(getStoresList, (s) => s?.[id]?.stores ?? []);
export const getActiveStore = createSelector(rootSelector, (s) => s.activeStore);
export const getStoresListErrorCode = createSelector(rootSelector, (s) => s.errorCode);

export const fetchStores = () => async (dispatch: Dispatch, getState: () => RootState) => {
  const state = getState();
  const qaCookie = getQaCookies(state.cookie);
  const lang = getLang();
  const domain = getDomain(getHostname(state.host || ''));
  const countryCode = getCountryCode(domain);
  const { ORCHESTRATOR_HOST, API_KEY } = getEnv(state);
  const params = {
    lang,
    countryCode,
  };
  const options: GetStoresConfig = {
    host: ORCHESTRATOR_HOST,
    params,
    config: {
      headers: {
        'x-api-key': API_KEY,
      },
    },
  };

  if (qaCookie) {
    options.config = { ...options.config, headers: { ...options.config?.headers, cookie: qaCookie } };
  }

  return dispatch(fetchStoresThunk(options));
};
